module.exports = __webpack_public_path__ + "static/media/gw7.1866b2e9.webp";